export const FREEPRO_VOICEMAIL_SHORT_NUMBER: string = '666';
export const FREEPRO_VOICEMAIL_LOCAL_NUMBER: string = '0564656667';
export const FREEPRO_VOICEMAIL_INTERNATIONAL_NUMBER: string = '+33564656667';
